import React from "react";
import { AiFillStar } from "react-icons/ai";
function RatingCard({ rating = 5.0 }) {
  return (
    <div className="flex items-center justify-center gap-1 rounded bg-[#57BE53] px-2 py-1 text-xxs font-medium text-white shadow sm:text-xs">
      <AiFillStar className="text-xs text-white sm:text-sm" /> {rating}
    </div>
  );
}

export default RatingCard;
